<template>
  <el-dialog
    :title="$t('productLabelManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>{{ $t('productLabelManage.confirmRemoveLabel') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteProductLabelModel">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteProductLabel">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteProductLabel } from '@/api/goods/productLabelApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteProductLabel',
  data() {
    return {
      dialogVisible: false,
      deleteProductLabelInfo: {}
    }
  },
  methods: {
    open(product) {
      this.deleteProductLabelInfo = { ...product }
      this.dialogVisible = true
    },
    handleClose(done) {
      this.closeDeleteProductLabelModel()
      done()
    },
    closeDeleteProductLabelModel() {
      this.dialogVisible = false
    },
    async deleteProductLabel() {
      try {
        this.deleteProductLabelInfo.shopId = getShopId()
        const res = await deleteProductLabel(this.deleteProductLabelInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.deleteSuccess'))
          this.closeDeleteProductLabelModel()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('common.deleteFailed'))
        console.error('删除失败:', error)
      }
    }
  }
}
</script>